import config from './config';

let env = config.get('env');

export default {
    'apigateway': env !== 'local' ? `https://${config.get('apiGatewayHost')}:${config.get('apiGatewayPort')}` : `http://${config.get('apiGatewayHost')}:${config.get('apiGatewayPort')}`
}
